export function Archive(organizationID: number, userPaymentMethodID: number): string {
	return `/v1/organizations/${organizationID}/payment-methods/${userPaymentMethodID}/archive`;
}

